import { resetAuth } from '../actions/authentication';
import { clearStoredSession, purgeLegacyKeys, MODE_KEYCLOAK } from './session';
import { logout as keycloakLogout } from './keycloak';

/**
 * Sign the user out (Trello 27MN7nRG).
 * 1. The local state is purged FIRST (before any navigation), otherwise the signed-in redirect
 *    of the app would loop back to /admin.
 * 2. Keycloak mode: keycloak.logout() calls the realm end_session_endpoint (id_token_hint +
 *    post_logout_redirect_uri), so the SSO session is really closed, then back to `/`.
 * 3. Native modes: full reload on `/`, which also resets the QR/countdown component state.
 */
export function signOut(session, dispatch) {
    dispatch(resetAuth());
    clearStoredSession();
    purgeLegacyKeys();
    if (session && session.mode === MODE_KEYCLOAK) {
        return keycloakLogout();
    }
    window.location.assign('/');
    return undefined;
}
